import { toast } from "react-toastify"
import api from "api/api"

export const GET_ACCOUNT_PAYMENT_MEANS = "[ACCOUNT PAYMENT MEANS] GET ACCOUNT PAYMENT MEANS"
export const SAVE_ACCOUNT_PAYMENT_MEAN = "[ACCOUNT PAYMENT MEANS] SAVE ACCOUNT PAYMENT MEAN"
export const DELETE_ACCOUNT_PAYMENT_MEAN = "[ACCOUNT PAYMENT MEANS] DELETE ACCOUNT PAYMENT MEAN"

export function getAccountPaymentMeansAction(accountBankId) {
  const request = api.get(`/account-payment-means/${accountBankId}`)
  return (dispatch) => {
    dispatch({ type: GET_ACCOUNT_PAYMENT_MEANS, payload: { loading: true } })
    request.then(({ data }) => {
      dispatch({ type: GET_ACCOUNT_PAYMENT_MEANS, payload: { data: data.data } })
    }).catch((error) => {
      console.log(GET_ACCOUNT_PAYMENT_MEANS, error)
    }).finally(() => {
      dispatch({ type: GET_ACCOUNT_PAYMENT_MEANS, payload: { loading: false } })
    })
  }
}

export function saveAccountPaymentMeanAction(accountBankId, paymentMeanCode, onSuccess) {
  const request = api.post(`/account-payment-means/${accountBankId}/code/${paymentMeanCode}`)
  return (dispatch) => {
    dispatch({ type: SAVE_ACCOUNT_PAYMENT_MEAN, payload: { saving_code: paymentMeanCode } })
    request.then(({ data }) => {
      if (Number(data.status) !== 200) {
        toast.error(data.message)
        return
      }
      dispatch({ type: SAVE_ACCOUNT_PAYMENT_MEAN, payload: { saved_code: paymentMeanCode } })
      if (onSuccess) onSuccess()
    }).catch((error) => {
      console.log(SAVE_ACCOUNT_PAYMENT_MEAN, error)
    }).finally(() => {
      dispatch({ type: SAVE_ACCOUNT_PAYMENT_MEAN, payload: { saving_code: paymentMeanCode } })
    })
  }
}

export function deleteAccountPaymentMeanAction(accountBankId, paymentMeanCode, onSuccess) {
  const request = api.delete(`/account-payment-means/${accountBankId}/code/${paymentMeanCode}`)
  return (dispatch) => {
    dispatch({ type: DELETE_ACCOUNT_PAYMENT_MEAN, payload: { saving_code: paymentMeanCode } })
    request.then(({ data }) => {
      if (Number(data.status) !== 200) {
        toast.error(data.message)
        return
      }
      dispatch({ type: DELETE_ACCOUNT_PAYMENT_MEAN, payload: { saved_code: paymentMeanCode } })
      if (onSuccess) onSuccess()
    }).catch((error) => {
      console.log(DELETE_ACCOUNT_PAYMENT_MEAN, error)
    }).finally(() => {
      dispatch({ type: DELETE_ACCOUNT_PAYMENT_MEAN, payload: { saving_code: paymentMeanCode } })
    })
  }
}